export class SystemAttributes {
    cellId: number | undefined = undefined;
    activityId: number | undefined = undefined;
}